import Api from '@/services/Api'
import ApiDownloadReporte from '@/services/Api'

const URL_GET_DATE = 'fecha-actual/';

export default {

    fecha_actual(params) {
        return Api().get(URL_GET_DATE);
    },

    reporte(params) {
        let url = params['url'];
        return ApiDownloadReporte().get(url);
    }

}